module.exports = __webpack_public_path__ + "static/media/10. Mb1, Superficie Sólida, 19 x 20 x 17 cm, 2020 copy.0b2248d8.png";